import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useToast } from '../../components/Toast';
import { featuresFaq } from '../../data/support/featuresFaq';
import { SupportGuideLayout, SupportHelpFooter, SupportLinkList, openChannelTalk } from './SupportGuide';

export const FEATURES_PATH = '/support/features';

const stripHtml = (html) => html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();

export const buildFeaturesFaqSchema = (faqs = featuresFaq) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: { '@type': 'Answer', text: stripHtml(faq.answer) },
  })),
});

const FeaturesPage = () => {
  const { showToast } = useToast();

  return (
    <>
      <Helmet>
        <title>기능별 사용법 | 생기부·채점·학습지·PPT·한글 문서 | 왓퀴즈</title>
        <meta name="description" content="왓퀴즈 기능별 사용법. AI 생기부 생성·검사, 서술형 채점, 평가계획서, 학습지·PPT·이미지, 한글(HWP) 양식 채우기, 파일 첨부, 저장 위치를 화면과 함께 안내해요." />
        <meta property="og:title" content="기능별 사용법 | 왓퀴즈" />
        <meta property="og:description" content="생기부, 채점, 학습지, PPT, 한글 문서까지 왓퀴즈 기능을 화면과 함께 안내해요." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href={`https://whatquiz.co.kr${FEATURES_PATH}`} />
        <script type="application/ld+json">{JSON.stringify(buildFeaturesFaqSchema())}</script>
      </Helmet>

      <SupportGuideLayout current="기능별 사용법">
        <section className="sg__hero">
          <h1>기능별 사용법</h1>
          <p>궁금한 기능을 눌러 화면과 함께 보세요</p>
          <Link to="/chat?new=true" className="sg__cta">AI 채팅 시작하기</Link>
        </section>

        <section className="sg__card">
          <h2>자주 찾는 기능</h2>
          <SupportLinkList
            items={featuresFaq.map((faq) => ({ to: `/support/faq/${faq.id}`, title: faq.question }))}
          />
        </section>

        <SupportHelpFooter text="찾는 기능이 없으면" onChat={() => openChannelTalk(showToast)} />
      </SupportGuideLayout>
    </>
  );
};

export default FeaturesPage;
